import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import Lock from "@material-ui/icons/Lock";
// core components
import AuthHeader from "components/Headers/AuthHeader.js";

import boxShadows from "assets/theme/box-shadow.js";

function LockPage() {
  const theme = useTheme();
  return (
    <>
      <AuthHeader
        title="Lock screen"
        description="Better to be safe than sorry."
      ></AuthHeader>
      <Container
        component={Box}
        maxWidth="xl"
        sx={{
          marginTop: "-8rem",
          paddingBottom: "3rem",
          position: "relative",
          zIndex: "101",
        }}
      >
        <Box component={Grid} container sx={{ justifyContent: "center" }}>
          <Grid item xs={12} md={7} lg={5}>
            <Card
              sx={{
                boxShadow: boxShadows.boxShadow + "!important",
                border: "0!important",
                background: theme.palette.background.default,
              }}
            >
              <Box component={Grid} container sx={{ justifyContent: "center" }}>
                <Grid item xs={12} lg={3}>
                  <Box sx={{ position: "relative" }}>
                    <Box
                      component="img"
                      src={
                        require("assets/img/theme/team-4-800x800.jpg").default
                      }
                      alt="..."
                      sx={{
                        maxWidth: "140px",
                        borderRadius: "50%",
                        position: "absolute",
                        left: "50%",
                        border: "3px solid " + theme.palette.white.main,
                        boxShadow: boxShadows.boxShadow + "!important",
                        verticalAlign: "middle",
                        transform: "translate(-50%,-50%) scale(1)",
                        transition: "all .15s ease",
                        "&:hover": {
                          transform: "translate(-50%,-50%) scale(1.03)",
                        },
                      }}
                    />
                  </Box>
                </Grid>
              </Box>
              <CardContent
                sx={{
                  paddingTop: "6rem !important",
                  textAlign: "center",
                  [theme.breakpoints.up("md")]: {
                    padding: "3rem",
                  },
                }}
              >
                <Typography
                  variant="h3"
                  component="h3"
                  sx={{ marginBottom: "1.5rem" }}
                >
                  Jessica Jones
                </Typography>
                <FormControl
                  variant="filled"
                  component={Box}
                  sx={{ width: "100%", marginBottom: "1rem!important" }}
                >
                  <FilledInput
                    autoComplete="off"
                    type="password"
                    placeholder="Password"
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <Button
                  variant="contained"
                  color="info"
                  sx={{ marginTop: "1rem" }}
                >
                  Unlock
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default LockPage;
